<template>
    <article ref="container"
             :class="{ 'collapsible--collapsed' : !expanded }"
             class="collapsible"
    >
        <header :class="{ 'collapsible__header--preview-only' : previewOnly }"
                class="collapsible__header"
        >
            <!-- TODO: let choose heading level for accessibility -->
            <h2 class="collapsible-title heading-with-separator">
                <span
                    class="heading-with-separator__inner"
                    :class="{ 'heading-error' : isError }"
                >
                    {{ titleText }}
                    <svg
                        v-if="isError"
                        :height="exceptionIconSize"
                        :width="exceptionIconSize"
                        class="exception-icon"
                    >
                        <use xlink:href="#exclamation-heavy" />
                    </svg>
                </span>
            </h2>
            <base-icon-button v-if="!previewOnly"
                              secondary
                              class="collapsible__toggle"
                              :title-text="toggleLabel"
                              :disabled="disabled"
                              @click="toggle"
            >
                <svg width="12"
                     height="8"
                >
                    <use xlink:href="#chevron-down" />
                </svg>
            </base-icon-button>
        </header>

        <div class="collapsible__content">
            <div :class="{ 'collapsible__content-inner--disabled' : disabled }"
                 class="collapsible__content-inner"
            >
                <slot />
            </div>
        </div>
    </article>
</template>

<script>
import '@/assets/icons/chevron-down.svg';
import '@/assets/icons/exclamation-heavy.svg';
import { $t } from '@/translations';
import BaseIconButton from '@/components/base/BaseIconButton';

export default {
    name: 'CollapsibleBlock',
    components: {
        BaseIconButton,
    },
    props: {
        titleText: {
            type: String,
            default: 'Collapsible title',
        },
        toggleLabel: {
            type: String,
            default: $t('general.toggle'),
        },
        collapsed: {
            type: Boolean,
            default: undefined,
        },
        previewOnly: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        isError: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            expanded: this.collapsed !== undefined ? !this.collapsed : true,
            isCollapsed: this.collapsed || false,
            exceptionIconSize: 18,
        };
    },
    watch: {
        collapsed(val) {
            this.expanded = !val;
        },
    },
    methods: {
        toggle() {
            this.expand(!this.expanded);
        },
        expand(state = true) {
            this.expanded = state;
            this.isCollapsed = !state;
            this.$emit('update:collapsed', !state);
            this.$emit('toggled', state);
        },
    },
};
</script>

<style scoped lang="scss">
.collapsible {
    $_this: &;

    margin-bottom: 20px;

    &__header {
        position: relative;
        padding-right: $icon-button-size-default;

        &--preview-only {
            padding-right: 0;
        }

        .heading-with-separator {
            &__inner {
                line-height: 20px;

                &.heading-error {
                    color: $color-error;
                }

                .exception-icon {
                    margin-bottom: -3px;
                    margin-left: 5px;
                }
            }
        }
    }

    &__toggle {
        position: absolute;
        top: 50%;
        right: 0;
        margin-top: -$icon-button-size-default/2;

        svg {
            transform: rotate(180deg);
            transition: $transition-quick;
        }
    }

    &__content {
        height: auto;
        transition: $transition-long;
        opacity: 1;
    }

    &__content-inner {
        padding-bottom: 32px;

        &--disabled {
            padding-bottom: 8px;
        }
    }

    &:last-child {
        margin-bottom: 0;

        #{$_this}__content-inner {
            padding-bottom: 12px;
        }
    }

    &--collapsed {
        #{$_this}__content {
            height: 0;
            overflow: hidden;
            opacity: 0;
        }

        #{$_this}__toggle {
            svg {
                margin-top: 1px;
                transform: rotate(0);
            }
        }
    }
}
</style>
